import { procurementAPI } from "../../axios";

export const actions = {
    GetAvailablePPMP(context, data){
        return procurementAPI.get(`CampusPrItem/Available/Ppmp/${data.campusId}/${data.cycle}`);
    },
    GetAvailableApiResource(context, data){
        return procurementAPI.get(`CampusPrItem/Available/${data.cycle}/${data.fundSourceId}/${data.fundClassificationId}/${data.itemCategoryId}`);
    },
    UpdateCampusPrItem(context, data){
        return procurementAPI.put(`CampusPrItem/Update/${data.id}`, data);
    },
    DeleteCampusPrItem(context, data){
        return procurementAPI.delete(`CampusPrItem/Remove/${data}`);
    },
    CreateCampusPrItem(context, data){
        return procurementAPI.post(`CampusPrItem/Add/${data.id}`, data);
    },
}